export default {
  required: 'Wymagane',
  requiredField: 'To pole jest wymagane'
}
